import React from "react";
import "./style.css";

const BloomLoading = () => {
  return (
    <div className="new-loading">
      <div className="new-loading__drops">
        <div className="new-loading__drop new-loading__drop--1">
          <svg width="16" height="22" viewBox="0 0 16 22" fill="currentColor">
            <path d="M8 0C8 0 0 9.33 0 14a8 8 0 1 0 16 0C16 9.33 8 0 8 0z" />
          </svg>
        </div>
        <div className="new-loading__drop new-loading__drop--2">
          <svg width="16" height="22" viewBox="0 0 16 22" fill="currentColor">
            <path d="M8 0C8 0 0 9.33 0 14a8 8 0 1 0 16 0C16 9.33 8 0 8 0z" />
          </svg>
        </div>
        <div className="new-loading__drop new-loading__drop--3">
          <svg width="16" height="22" viewBox="0 0 16 22" fill="currentColor">
            <path d="M8 0C8 0 0 9.33 0 14a8 8 0 1 0 16 0C16 9.33 8 0 8 0z" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default BloomLoading;
